import $ from 'jquery';

export const _filter = () => {
  fixedScroll();
  openCloseFilter();
};

const openCloseFilter = () => {
  $('.js-open-filter').on('click', function () {
    $('.c-aside').addClass('active');
  });

  $('.js-close-filter').on('click', function () {
    $('.c-aside').removeClass('active');
  });
};
const fixedScroll = () => {
  var header = document.querySelector('.js-fixed-header');
  var spacer = document.getElementById('js-fixed-header-spacer');
  if (!header || !spacer) return;

  // Atualiza a altura do espaçador para igualar ao header
  function updateSpacerHeight() {
    spacer.style.height = header.offsetHeight + 'px';
  }
  updateSpacerHeight();
  window.addEventListener('resize', updateSpacerHeight);

  var headerTop = header.getBoundingClientRect().top + window.scrollY;

  // Captura o espaçamento lateral do header antes de fixar
  var headerRect = header.getBoundingClientRect();
  var parentRect = header.parentElement.getBoundingClientRect();
  var leftSpacing = headerRect.left - parentRect.left;
  var rightSpacing = parentRect.right - headerRect.right;

  function onScroll() {
    if (window.scrollY + 70 >= headerTop) {
      header.style.position = 'fixed';
      header.style.top = '70px';
      header.style.left = '0px';
      header.style.right = '0px';
      header.style.paddingTop = '10px';
      header.style.paddingBottom = '10px';
      header.style.paddingLeft = parentRect.left + leftSpacing + 'px';
      header.style.paddingRight = rightSpacing + 'px';
      header.style.width = '100%';
      header.style.background = '#fff';
      header.style.zIndex = '100';
      spacer.style.display = 'block';
    } else {
      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.right = '';
      header.style.paddingTop = '';
      header.style.paddingBottom = '';
      header.style.paddingLeft = '';
      header.style.paddingRight = '';
      header.style.width = '';
      header.style.zIndex = '';
      header.style.background = '';
      spacer.style.display = 'none';
    }
  }

  window.addEventListener('scroll', onScroll);
};
